import React from 'react'
import { Popover, WithPopover } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import {
  Button,
  IconPencil20,
} from '@lightspeed/unified-components-helios-theme/react'
import { SearchableUserList } from '../../../shared/SearchableUserList'
import {
  useSalesPersonSelectModel,
  SalesPersonSelectProps,
} from './useSalesPersonSelectModel'

/**
 * This component renders a button that displays the currently selected "sold by" user.
 * When clicked, it opens a popover containing a searchable list of users to select from.
 * @param props
 * @returns
 */
export const SalesPersonSelect = (props: SalesPersonSelectProps) => {
  const t = useT()
  const model = useSalesPersonSelectModel(props)

  if (!model.selectedUser) {
    return null
  }

  return (
    <div className="uc-base">
      <WithPopover className="vd-popover--with-list" direction="left">
        <Button
          appearance="ghost"
          type="button"
          onClick={model.showPopover}
          disabled={model.isDisabled}
          prefixSlot={<IconPencil20 />}
          customDataAttributes={{
            container: {
              'data-track': 'sales-person-select',
            },
          }}
        >
          {t('Sold by {userName}', {
            userName: model.selectedUser.displayName,
          })}
        </Button>

        {model.isPopoverOpen && (
          <Popover
            onClose={model.hidePopover}
            className="sales-person-popover-container"
          >
            <SearchableUserList
              users={model.users}
              activeUserId={model.selectedUser.id}
              onSelectHandler={model.onSelectHandler}
            />
          </Popover>
        )}
      </WithPopover>
    </div>
  )
}
